import { render, staticRenderFns } from "./partd.vue?vue&type=template&id=087c6cd8&scoped=true&"
import script from "./partd.vue?vue&type=script&lang=js&"
export * from "./partd.vue?vue&type=script&lang=js&"
import style0 from "./partd.vue?vue&type=style&index=0&id=087c6cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087c6cd8",
  null
  
)

export default component.exports